
      // 根据环境变量设置页面标题和图标
      document.addEventListener('DOMContentLoaded', function () {
        if (import.meta.env.VITE_APP_PLATFORM_TYPE === 'nxjp') {
          localStorage.setItem('DefaultDomain', 'true')
          document.title = '宁夏建培-建筑行业职业技能服务平台'
          // 设置宁夏建培的favicon
          var existingFavicon = document.querySelector('link[rel="icon"]')
          if (existingFavicon) {
            existingFavicon.remove()
          }
          var link = document.createElement('link')
          link.rel = 'icon'
          link.type = 'image/png'
          link.href = '/nx-logo.png'
          document.head.appendChild(link)
        } else {
          localStorage.setItem('DefaultDomain', 'false')
          document.title = '行企通-建筑行业职业技能服务平台'
          // 设置行企通的favicon
          var existingFavicon = document.querySelector('link[rel="icon"]')
          if (existingFavicon) {
            existingFavicon.remove()
          }
          var link = document.createElement('link')
          link.rel = 'icon'
          link.type = 'image/png'
          link.href = '/logo.png'
          document.head.appendChild(link)
        }
      })
    